import config from '../config';

const CAP_DOCS_ENDPOINT = `${config.SPLAT_CAP_BASE_URL}/prospects`;
const CAP_ESIGN_URL_ENDPOINT = `${config.SPLAT_CAP_BASE_URL}/docEsign`;
const CREATE_PAYMENT_REQUEST_ENDPOINT = `${config.PAYMENT_API_BASE_URL}/v1/create-payment-request`;
const CURRENT_WEATHER_ENDPOINT = `${config.WEATHER_API_BASE_URL}/weather`;
const DOCUMENT_URL_ENDPOINT = `${config.USER_API_BASE_URL}/document-url`;
const DOCUMENTS_ENDPOINT = `${config.USER_API_BASE_URL}/documents-v2`;
const FEEDBACK_ENDPOINT = `${config.USER_API_BASE_URL}/feedback`;
const FORGOT_PASSWORD_ENDPOINT = `${config.USER_API_BASE_URL}/forgotPassword`;
const GET_CASES_ENDPOINT = `${config.CASES_API_BASE_URL}/cases`;
const GET_METER_INFO_ENDPOINT = `${config.USER_API_BASE_URL}/meter-info`;
const GET_GLOBAL_NOTIFICATION_MESSAGES_ENDPOINT = `${config.USER_API_BASE_URL}/message`;
const GET_PENDING_PAYMENT_ENDPOINT = `${config.PAYMENT_API_BASE_URL}/recent-payment-history`;
const GET_GENERATED_PAYMENT_LINK_ENDPOINT = `${config.PAYMENT_API_BASE_URL}/generate-payment-link`;
const GET_PROSPECT_BILLING_INFO_ENDPOINT = `${config.PAYMENT_API_BASE_URL}/billing-history-prospect`;
const GET_PROSPECT_BILLING_INVOICE_ENDPOINT = `${config.PAYMENT_API_BASE_URL}/billing-invoice-prospect`;
const GET_RECURRING_BILLING_ENDPOINT = `${config.PAYMENT_API_BASE_URL}/recurring-billing-details`;
const GRID_SITE_STATUS_ENDPOINT = `${config.USER_API_BASE_URL}/grid-status`;
const LAST_READINGS_ENDPOINT = `${config.USER_API_BASE_URL}/last-meter-reading`;
const LIST_CONTRACT_GENERATIONS_MONTHLY_ENDPOINT = `${config.USER_API_BASE_URL}/monthly-contract-generation`;
const LIST_DAILY_BATTERY_ENDPOINT = `${config.USER_API_BASE_URL}/daily-battery`;
const LIST_DAILY_PERFORMANCE_ENDPOINT = `${config.USER_API_BASE_URL}/daily-performance`;
const LIST_FIFTEEN_MINUTE_PRODUCTION_ENDPOINT = `${config.USER_API_BASE_URL}/fifteen-minute-performance`;
const LIST_FS_DISPATCH_ENDPOINT = `${config.CASES_API_BASE_URL}/fs-dispatch`;
const LIST_HOURLY_BATTERY_ENDPOINT = `${config.USER_API_BASE_URL}/hourly-battery`;
const LIST_MONTHLY_PERFORMANCE_ENDPOINT = `${config.USER_API_BASE_URL}/monthly-performance`;
const LIST_YEARLY_PERFORMANCE_ENDPOINT = `${config.USER_API_BASE_URL}/yearly-performance`;
const LOGIN_ENDPOINT = `${config.AUTH_API_BASE_URL}/authenticate`;
const LOGOUT_ENDPOINT = `${config.AUTH_API_BASE_URL}/logout`;
const NOTIFICATIONS_ENDPOINT = `${config.NOTIFICATION_BASE_URL}/notifications`;
const PASSWORDLESS_LOGIN_REQUEST_ENDPOINT = `${config.AUTH_API_BASE_URL}/request-passwordless`;
const PASSWORDLESS_LOGIN_RESPONSE_ENDPOINT = `${config.AUTH_API_BASE_URL}/respond-passwordless`;
const PRIMARY_CONTACT_INFO_ENDPOINT = `${config.USER_API_BASE_URL}/primary-contact`;
const PROFILE_ENDPOINT = `${config.AUTH_API_BASE_URL}/get-user`;
const PROPOSAL_TOKEN_ENDPOINT = `${config.USER_API_BASE_URL}/create-proposal-token`;
const PROSPECT_ENDPOINT = `${config.USER_API_BASE_URL}/prospect`;
const RATING_ENDPOINT = `${config.USER_API_BASE_URL}/rating`;
const REFERRAL_CREATE_ENDPOINT = `${config.REFERRAL_API_BASE_URL}/referral`;
const REFERRAL_GET_STATUSES_ENDPOINT = `${config.REFERRAL_API_BASE_URL}/v2/list`;
const RESEND_LOGIN_CODE_ENDPOINT = `${config.AUTH_API_BASE_URL}/resend-code`;
const RESET_PASSWORD_ENDPOINT = `${config.USER_API_BASE_URL}/resetPasswordWithCode`;
const SALESREP_ENDPOINT = `${config.USER_API_BASE_URL}/salesrep`;
const CASES_ENDPOINT = `${config.CASES_API_BASE_URL}/case`;
const SYSTEM_OVERVIEW_ENDPOINT = `${config.USER_API_BASE_URL}/system-overview`;
const UNENROLL_AUTOPAY_ENDPOINT = `${config.PAYMENT_API_BASE_URL}/v1/discontinue-autopay`;
const UPDATE_BILLING_PREFERENCE_ENDPOINT = `${config.USER_API_BASE_URL}/contract`;
const UPDATE_EMAIL_ENDPOINT = `${config.USER_API_BASE_URL}/request-email-update`;
const UPDATE_MOBILE_PHONE_ENDPOINT = `${config.USER_API_BASE_URL}/request-phone-update`;
const UPDATE_PRIMARY_PHONE_ENDPOINT = `${config.USER_API_BASE_URL}/contact`;
const VERIFY_EMAIL_CODE_ENDPOINT = `${config.USER_API_BASE_URL}/verify-email-update`;
const VERIFY_MOBILE_PHONE_CODE_ENDPOINT = `${config.USER_API_BASE_URL}/verify-phone-update`;
const WORKING_HOURS_ENDPOINT = `${config.SUPPORT_API_BASE_URL}/working-hours`;
export {
  CAP_DOCS_ENDPOINT,
  CAP_ESIGN_URL_ENDPOINT,
  CREATE_PAYMENT_REQUEST_ENDPOINT,
  CURRENT_WEATHER_ENDPOINT,
  DOCUMENTS_ENDPOINT,
  DOCUMENT_URL_ENDPOINT,
  FEEDBACK_ENDPOINT,
  FORGOT_PASSWORD_ENDPOINT,
  GET_CASES_ENDPOINT,
  GET_METER_INFO_ENDPOINT,
  GET_GLOBAL_NOTIFICATION_MESSAGES_ENDPOINT,
  GET_PENDING_PAYMENT_ENDPOINT,
  GET_GENERATED_PAYMENT_LINK_ENDPOINT,
  GET_PROSPECT_BILLING_INFO_ENDPOINT,
  GET_PROSPECT_BILLING_INVOICE_ENDPOINT,
  GET_RECURRING_BILLING_ENDPOINT,
  GRID_SITE_STATUS_ENDPOINT,
  LAST_READINGS_ENDPOINT,
  LIST_CONTRACT_GENERATIONS_MONTHLY_ENDPOINT,
  LIST_DAILY_BATTERY_ENDPOINT,
  LIST_DAILY_PERFORMANCE_ENDPOINT,
  LIST_FIFTEEN_MINUTE_PRODUCTION_ENDPOINT,
  LIST_FS_DISPATCH_ENDPOINT,
  LIST_HOURLY_BATTERY_ENDPOINT,
  LIST_MONTHLY_PERFORMANCE_ENDPOINT,
  LIST_YEARLY_PERFORMANCE_ENDPOINT,
  LOGIN_ENDPOINT,
  LOGOUT_ENDPOINT,
  NOTIFICATIONS_ENDPOINT,
  PASSWORDLESS_LOGIN_REQUEST_ENDPOINT,
  PASSWORDLESS_LOGIN_RESPONSE_ENDPOINT,
  PRIMARY_CONTACT_INFO_ENDPOINT,
  PROFILE_ENDPOINT,
  PROPOSAL_TOKEN_ENDPOINT,
  PROSPECT_ENDPOINT,
  RATING_ENDPOINT,
  REFERRAL_CREATE_ENDPOINT,
  REFERRAL_GET_STATUSES_ENDPOINT,
  RESEND_LOGIN_CODE_ENDPOINT,
  RESET_PASSWORD_ENDPOINT,
  SALESREP_ENDPOINT,
  CASES_ENDPOINT,
  SYSTEM_OVERVIEW_ENDPOINT,
  UNENROLL_AUTOPAY_ENDPOINT,
  UPDATE_BILLING_PREFERENCE_ENDPOINT,
  UPDATE_EMAIL_ENDPOINT,
  UPDATE_MOBILE_PHONE_ENDPOINT,
  UPDATE_PRIMARY_PHONE_ENDPOINT,
  VERIFY_EMAIL_CODE_ENDPOINT,
  VERIFY_MOBILE_PHONE_CODE_ENDPOINT,
  WORKING_HOURS_ENDPOINT,
};
